const four = (
  <div>
    <h2 id="a-place-to-stay">Helplessness</h2>
    <p>
      Myles had known since his first day as Ms. Lenore's assistant that Beth's
      closed on Sundays and, for the whole week, had wondered what would happen
      then. He didn't know if would be allowed to stay when the shop was closed
      for the date or where he would go. He was still unsure about his situation
      on Saturday, until Ms. Lenore approached him that afternoon before
      closing.
    </p>
    <p>
      &quot;Myles,&quot; Ms. Lenore said slowly, crouching down and lowering her
      eye down level to Myles'. &quot;Beth's is closed tomorrow.&quot;
    </p>
    <p>
      Myles felt a flash of panic. Was she finally going to tell him he couldn't
      sleep at Beth's anymore? Was she going to tell him she didn't want him
      getting in the way of running the shop anymore? Where would he go?
    </p>
    <p>
      &quot;I have a spare bed,&quot; She continued. &quot;Would you like to
      stay with me?&quot;
    </p>
    <p>
      He let out a relieved breath and nodded his head, not trusting himself to
      be able to speak. Myles hadn't realized how much he had gotten used to the
      comfort of Beth's and Ms. Lenore's calm presence and he was grateful to be
      invited to 's home. Despite Ms. Lenore's obvious realization that he was a
      runaway of sorts, she had never brought up Myles's situation or pried into
      his past, tiptoeing around Myles's discomfort with the situation with
      nothing more than concerned looks.
    </p>
    <p>
      &quot;Well then,&quot; Ms. Lenore smiled at him. &quot;Let's close up the
      shop.&quot;
    </p>
    <p>
      Ms. Lenore lived in a small wizard of community mostly lived in by owners
      of long-standing family shops in Diagon Alley that was connected to the
      &quot;space&quot; fit inside Muggle London. It was connected in the Lower
      Alley,
    </p>
    <p>
      So they walked down Diagon Alley. The shops on the street became poorer
      and poorer in quality, and the frequency of closed stores became higher
      and higher. It was very different, however, from Knockturn Alley.
      Knockturn Alley had had a dark dangerous feel about it, and the poorly
      constructed shops in it had always been that way. The shops on the low end
      of Diagon Alley were marked by permanent &quot;closed&quot; signs and
      deteriorated maintenance.
    </p>
    <p>
      Ms. Lenore was surprised when he asked why the shops were closing, giving
      him the worried and curious look he occasionally got when he asked
      something that everyone should know. He had gotten that same look when he
      had asked who Harry Potter was.
    </p>
    <p>
      &quot;Ever since Gunore's Grand General opened on the far side of the
      Leaky Cauldron the lower end of Diagon Alley has been struggling. Gunore
      sells just about everything you'll find on the Alley and often at a
      cheaper price. It hasn't been as hard on Beth's, my inventory is only a
      part of my revenue, but a lot of the other shops haven't been able to keep
      afloat.&quot; Ms. Lenore explained, sounding a bit resigned as she looked
      at the closed shops around her.
    </p>
    <p>
      They took a shortcut as they neared the Lower Alley, walking down a street
      of houses that felt only marginally safer than Knockturn Alley. Ms.
      Lenore, however, who walked down this street everyday looked fully
      comfortable, exchanging amicable nods with wizards and witches as they
      passed. While Myles felt safe in Ms. Lenore's protection, he hadn't fully
      let his guard down since leaving the Orphanage, keeping his eyes open,
      even if not entirely sure what he was looking for.
    </p>
    <p>
      So he noticed when a witch hurriedly entered her home, glancing behind him
      and Ms. Lenore. Myles turned to look behind him, wondering what had caused
      the woman's reaction and was met with a flash of light. Suddenly Ms.
      Lenore was moving beside him and the red lights shooting at them bounced
      away into the sky with a shouted incantation and flourish of her wand.
    </p>
    <p>
      He caught a glimpse of the two wizards stood ahead of them in the narrow
      street, wands held out and moving. They were dressed in rough clothing and
      the color in their face held an unhealthily pale tint, contrasting with
      the dark bags under their eyes. They still moved quickly enough however,
      throwing spells at the translucent white shield Ms. Lenore had erected the
      moment before. Myles hadn't heard the first two spells that had been sent
      at them, but now incantations were shouted, the voices of the two wizards
      escalating with the exchange of magic.
    </p>
    <p>
      Myles stood there stunned for long moments that felt like hours but lasted
      only a few seconds. Flashing lights shot between the two wizards and Ms.
      Lenore, whose steady calm had been replaced by a panicked desperation. The
      see through white shield she had erected with 'protego' was broken almost
      immediately, and she was saved only by the fact that the wizards,
      miscordinatinating their attack, had both cast shield breaking spells and
      the second passed harmlessly through Ms. Lenore.
    </p>
    <p>
      She returned with a flick of her wand that seemed to make one of the
      wizards' wand arms jerk up, but accomplished nothing else. One of the
      wizards performed another shield breaking spell, and this time the other
      wizard cast a different spell. Ms. Lenore, shieldless, dived out of the
      way of the red bolt shooting at her, landing hard on the ground.
    </p>
    <p>
      Mrs. Lenore's luck held and a man behind the two attackers, who Mrs.
      Lenore had nodded to on their way by, distracted the two wizards, giving
      her enough time to get back on her feet. The timid and frightened looking
      man shot a spell at the wizard closest to him, but the spell was easily
      deflected and the pale wizard's partner took down the man behind them with
      a sinister looking ball of darkness that broke through the man's fragile
      looking shield. Ms. Lenore shouted the man's name as he fell, looking
      sickened at the sight.
    </p>
    <p>
      The two wizards, with their twitching mouths and oddly focused eyes, did
      not look evil so much as unhinged and desperate. A volley of spells
      ensued, with Ms. Lenore able to keep up with them, if just barely. She
      countered an offense spell with her wand, the yellow light of the curse
      dissipating at the touch, and dealt with a mass of black coils heading at
      her with a burst of fire that scorched the air around them. Under the
      guise of the fire she broke the ground below them into rubble with a hard
      slash of her wand and sent the rocks shooting at the two wizards.
    </p>
    <p>
      &quot;Myles,&quot; she gasped, having bought a few seconds of time.
      &quot;Run!&quot;
    </p>
    <p>
      Myles's trance was broken and, with a single look back back and around
      wishing he could help but seeing no way a 'reparo' or 'nits' would deter
      the two wizards, he ran. He sprinted in the opposite direction, running
      towards the Lower Alley. He heard one of the two wizards shout &quot;Get
      him!&quot; and realized with sudden clarity that the two men were there
      for him, they'd come because he'd left the Orphanage. Myles risked a
      glance back at a clamour of noise and saw Ms. Lenore dropping one of the
      two even as the other wizard hit her with spell that threw her body like a
      doll, violently crashing her into a house. The wooden wall collapsed under
      the impact with a sickening crack, her body disappearing into the hole in
      the house.
    </p>
    <p>
      A pit formed in Myles's stomach and he faltered in his run, stumbling in
      shock. He saw the still standing wizard chasing him, wand out and throwing
      a spell, and panic pushed thoughts of Ms. Lenore to the back of his mind.
      He dove to the side and the red ball of light grazed his side, numbing
      where it hit and knocking him to the ground. Myles scrambled to his feet
      and raced for the corner, making it before the next spell came.
    </p>
    <p>
      He experienced a momentary relief at making the corner, which disappeared
      instantly as the pale and haggard wizard popped into existence in front of
      him. Their eyes met as the wizard raised his wand again and Myles dashed
      for the door to the house beside him, the only escape or cover nearby. He
      hoped with a desperate will that it was unlocked, and the lock clicked in
      response.
    </p>
    <p>
      Myles tore into the house. There was a kitchen ahead of him, tended to by
      a startled old witch who had drawn her wand and aimed at him. She shouted
      at him but he didn't pay her words any heed, hearing the wizard only steps
      behind him. He saw a fireplace and a ceramic bowl of powder beside it and
      came up with a half formed plan.
    </p>
    <p>
      Ms. Lenore had often taken the Flu to go on house calls and, while Myles
      had never done it, there didn't seem to be any special trick to using it.
      He grabbed the Flu powder and thought of the only address he knew.
    </p>
    <p>
      &quot;Seren Manor, 18th Knightdale Valley.&quot; Myles shouted, throwing
      the powder into the fire and jumping in. He felt a twist in his stomach
      and a wave of warmth rush through his body and suddenly he was inside of a
      different fireplace.
    </p>
    <p>
      The living room before him, in contrast to the one he had just left, was
      finely decorated. Every piece of furniture, carpet, and decoration inside
      it was thoughtfully placed, aligned, and picked to fit the unobtrusive
      color scheme of dark wood and earth tones. Yet several oddities broke the
      clearly planned layout: a large pink stuffed animal, an animated model of
      an exotic and scaly beast, a ugly plant with shaking tendril-like vines.
      Cecilia sat curled up in a cushioned chair far too big for her, reading a
      book and twirling a quill in between her fingers. Her acacia wand was
      settled on her ear, bared by a shiny raven pin that swept the side of her
      hair back.
    </p>
    <p>
      Myles saw all this for a split second before he was violently flipped
      upside down, streaks of velvet peeling off of the wall above the
      fireplace, pulling him up to the roof and tightly wrapping his body.
      Cecilia looked up from where she sat engrossed in her book, blinking up at
      him.
    </p>
    <p>
      &quot;You should've owled first, it's awfully rude to show up
      unannounced.&quot; Cecilia said, but she was smiling as she rose.
      &quot;Imagine if I hadn't been fully dressed.&quot;
    </p>
    <p>
      A second later, there was another flash below him, followed by grunt and
      an attempted spell cast. The velvet streaks moved again and, while Myles
      couldn't look down, he realized the wizard chasing him had attempted to
      follow him here and had gotten himself caught up in the flu's protective
      charms just like him.
    </p>
    <p>
      &quot;Cecilia, love, you didn't say you'd be having guests over.&quot; A
      woman said brightly, rounding a corner and coming into the edges of
      Myles's vision. She had the same odd look in her eyes that Cecilia did,
      though the woman's were more abstract and less focused.
    </p>
    <p>
      &quot;This is Myles, mother.&quot; Cecilia responded to the woman.
      &quot;Myles-not-Muren. And this, well, I'm not at all sure who this is but
      he doesn't look friendly.&quot;
    </p>
    <p>
      &quot;He does look very angry.&quot; Cecilia's mother said curiously,
      peering at the struggling wizard who was fighting the red velvet strips
      with his tongue and arm, sputtering as he unsuccessfully tried to cast a
      spell. &quot;Maybe your friend can tell us why.&quot;
    </p>
    <p>
      Cecilia pointed her wand at the velvet strips encapsulating him,
      instructing them to gently put Myles down. Gasping, the constrictive
      velvet strips had made it difficult to breath, he tried to explain,
      apologizing for bringing the man here as well as coming uninvited himself
      and trying to explain the attack. He didn't explain the situation well in
      his state of mind, adding details that had nothing to do with the story
      and forgetting important details. Ultimately, however, he managed to
      explain most of what happened and Cecilia's mother, Mrs. Luna Eden, flued
      to the ministry, bringing the velvet wrapped wizard with her.
    </p>
    <p>
      A finely dressed house elf served him and Cecilia tea and biscuits and
      while Myles had no appetite he drank the tea, more for something to do
      with his hands than any desire for the drink. He had half expected Cecilia
      to pester him with questions, especially since she had somehow figured he
      had lied to her about his last name, or even accuse him of not only
      intruding into her house but also bringing a dangerous wizard along with
      him. Cecilia, however, sat across from him in companionable silence,
      letting him recover in silence. She pulled out her book and read,
      occasionally glancing up at him.
    </p>
    <p>
      Eventually Cecilia's mother returned, a scarred middle-aged man
      accompanying her. He wore black robes with embroidered with scarlet and
      with a series of images set in white on the front. While the scars made
      his face intimidating, the expression on his face was slightly bored and
      rather uncaring.
    </p>
    <p>
      &quot;Myles?&quot; the man asked and Myles nodded his head. &quot;I'm
      Auror Rawlins. I was informed that you do not have parents or a legal
      guardian, is this true? Myles nodded again. &quot;I'm here to take you to
      the Department of Magical Law Enforcement. We'll need to hear your account
      on the attack in the Lower Alley and we'll settle this situation.&quot;
    </p>
    <p>
      Had Myles known more about the wizarding world and society in general, he
      would have thought it odd that a scarred and unsympathetic man who looked
      more suited to fighting dark wizards would be sent to retrieve an 11 year
      old child. But he didn't, and the man's countenance served to make him
      more apprehensive about going to the Ministry. At this point Myles had
      come to the conclusion that the Orphanage was not part of the Ministry or,
      as far as he could tell, wizarding society in general. There were, he had
      found by researching through books at Flourish and Blotts, no orphanages
      in Britain and most orphans were adopted into a family. Still, Myles had
      no idea what awaited him. He didn't know if he would be in trouble for the
      attack in the Lower Alley and, even if he wasn't, what would happen to
      him, the same book where he had found out about the wizarding orphanage
      had stated wizards came into their full rights at 17.
    </p>
    <p>
      &quot;Myles,&quot; Cecilia's mother said gravely. &quot;Remember to keep
      your shoes tied.&quot; Myles glanced down at his feet, thrown off balance
      by the comment and quite sure that the woman was insane.
    </p>
    <p>
      A smile tugged at the corners of Cecilia's mouth at his bewildered
      reaction. &quot;I'll see you at Hogwarts in a few days.&quot; She extended
      a hand and he shook it.
    </p>
    <p>
      Myles was reassured by Cecilia's reaction. She had said she would see him
      at Hogwarts, something she wouldn't have said if she thought he was in
      trouble.
    </p>
    <p>
      The Auror led him into the fireplace and they Flued to the Ministry of
      Magic. They exited in a grand and bustling hall, filled with the smell of
      burnt flu powder and magically appearing people. When Myles had arrived in
      Diagon Alley for the first time he had been stunned by the commotion and
      sheer number of people, unable to take everything in. The Ministry was
      similarly busy, though it's colors were restrained and it's decoration
      uniform.
    </p>
    <p>
      Myles took it all in as they strode through the building: grand white
      marble statues that rose nearly to ceiling, a wide mural depicting a
      wizard conquering a force of darkness, and the bustling mass of wizardry
      that moved around him. They entered through a wand checking station, at
      which the clerk decided to register Myles's wand as an
      &quot;undefined&quot; build.
    </p>
    <p>
      The Auror led him to an elevator filled with a number of wizards and
      witches, with a mass of paper airplanes filling the space above their
      heads. Myles had never seen an elevator before but he thought there had to
      be a better mode of transportation than a floating box that everyone
      needed to wait for. They got off on the second floor, labeled 'Department
      of Magical Law Enforcement.
    </p>
    <p>
      &quot;Bringing in dangerous criminals, ay?&quot;' The man who ran the desk
      in front of them gave the Auror escorting Myles a knowing smile and shot
      Myles a wink.
    </p>
    <p>
      &quot;Bah, I'm an Auror! Not a damned babysitter.&quot; The Auror replied
      irascible, not seeming to care that Myles was present. &quot;I'm supposed
      to be catching Dark Wizards.&quot;
    </p>
    <p>
      &quot;Yes, yes.&quot; The clerk replied, giving Myles the impression that
      he had this spiel many times before. &quot;Well there's a shortage of Dark
      Wizards at the moment so you'll have to make do, Merlin knows we're still
      busy enough. You can go ahead to room 301.&quot;
    </p>
    <p>
      Auror Rawlins scowled at the man and lead Myles down a corridor that lead
      to a room with '301' embroiled on the door. Another man met them there,
      with a badge on his chest that stated:
    </p>
    <p style={{ textAlign: "center", fontStyle: "bold", fontSize: 13 }}>
      Auror-in-training
    </p>
    <p style={{ textAlign: "center", fontStyle: "bold" }}>Phillip Mainser</p>
    <p>
      &quot;Rawlins, sir. Reporting for duty.&quot; The young, spindly man said
      in a voice that tried to be rough but barely managed to not squeak.
    </p>
    <p>
      &quot;Well, get in the room boy! You're not paid to sit around.&quot;
      Rawlins barked, making the Auror-in-training pale and jump to open the
      door in front of them.
    </p>
    <p>
      The room inside included only a wooden table and two comfortable cushioned
      chairs facing it. It was an interrogation room, though the soft brown
      colors of the wallpaper and carpeted floor intended it to be a comfortable
      one.
    </p>
    <p>
      &quot;Myles, was it? Sit down over here and we'll have a chat. You'll be
      along your way in no time.&quot; Rawlins clearly made an effort to keep
      his voice a little softer than when he was barking at the
      Auror-in-training who stood watching.
    </p>
    <p>
      He began to ask a series of questions, and Myles ended up telling the
      whole story. The Auror, however, clearly didn't believe him about the
      existence of the Orphanage, asking questions that pointed Myles towards
      admitting he was lying. He took Myles's account of the attack a bit more
      seriously, though he still seemed skeptical.
    </p>
    <p>
      &quot;Excuse me, sir. Is Mrs. Lenore going to be alright?&quot; Myles
      asked.
    </p>
    <p>
      &quot;A concussion, three broken ribs, admitted to St. Mungo's. She'll be
      up and running in a couple of days.&quot; The Auror replied. &quot;We'll
      have to get her account of the attack tomorrow. Seems to be a clear case
      of assault, though. Category 2, likely Brion junkies crazed on the drug or
      trying to steal money.&quot;
    </p>
    <p>
      Myles felt horrible about the injuries Mrs. Lenore had suffered for him.
      He ran his hand through the mess of dirty hair atop his ahead, remembering
      Mrs. Lenore leaning down to adjust his hair: the smell of fresh potion
      brewing in her hair and robes, her smile lighting up her face.
    </p>
    <p>
      His thoughts were broken by a red paper airplane flying in through the
      vents, making a shrill alarm sound as it flew through the air. The
      Auror-in-training jumped to grab at it in alarm and Auror Rawlins looked
      at it with the first traces of interest on his face that Myles had seen.
    </p>
    <p>
      &quot;Seventeen members of the Wizengamot have had their houses raided:
      two dead, multiple injured.&quot; The young man said. &quot;Requesting all
      available Aurors to duty.&quot;
    </p>
    <p>
      Before the trainee had even finished reading the notice another flew in,
      louder in volume than the first. &quot;Ten more manors of the Wizengamot
      raidex and of several other prominent families,&quot; he said, paling as
      he read the new paper. &quot;Requesting all on and off duty Aurors,
      Aurors-in-training, and Magical Law Enforcement Officers to duty.&quot;
    </p>
    <p>
      Another paper airplane flew in, but the trainee made no effort to read it.
      &quot;Nothing like this has happened since...&quot; The Auror trainee
      paled. &quot;Well, si-&quot;
    </p>
    <p>
      &quot;Since the war.&quot; Auror Rawlins finished grimly, unconsciously
      touching his fingers to his wand. &quot;Take the kid to the general office
      and then make yourself useful.&quot; He tore out of the room, the edges of
      his lips quirking up in excitement despite the grim set of his face.
    </p>
    <p>
      &quot;Well… umm,&quot; the Auror trainee looked a bit lost for a moment
      before he gained his composure, standing up straight, hardening his facial
      expression, and steadying his voice. &quot;Let's get you to the
      office.&quot;
    </p>
  </div>
);

export default four;
